import { Component, Input} from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { SalesChannel } from 'src/app/assabil-kernel/models/entities/control-tables/sales-channel';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
  selector: 'sales-channel-lov',
  templateUrl: './sales-channel-lov.component.html',
  styleUrls: ['./sales-channel-lov.component.scss']
})


export class SalesChannelLovComponent extends GenericLovComponent {

    @Input() code         : string; 
    @Input() name         : string; 

    salesChannels: SalesChannel[] = [];

    columns = [
        {  prop: 'salesChannelCode', name: 'Code'},
        {  prop: 'name',            name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<SalesChannelLovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "salesChannel";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.salesChannels = result;
    })
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
closeModal(row : SalesChannel){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
